/**
 * Export signature canvas as PNG in a stable horizontal orientation (width >= height)
 * for server storage and PDF stamping, regardless of on-screen CSS rotation.
 */
export function canvasToNormalizedSignatureBlob(canvas: HTMLCanvasElement): Promise<Blob | null> {
  return new Promise((resolve) => {
    if (canvas.width <= 0 || canvas.height <= 0) {
      resolve(null);
      return;
    }

    const exportCanvas = document.createElement('canvas');
    const ctx = exportCanvas.getContext('2d');
    if (!ctx) {
      resolve(null);
      return;
    }

    if (canvas.width >= canvas.height) {
      exportCanvas.width = canvas.width;
      exportCanvas.height = canvas.height;
      ctx.drawImage(canvas, 0, 0);
    } else {
      exportCanvas.width = canvas.height;
      exportCanvas.height = canvas.width;
      ctx.translate(0, exportCanvas.height);
      ctx.rotate(-Math.PI / 2);
      ctx.drawImage(canvas, 0, 0);
    }

    exportCanvas.toBlob((blob) => resolve(blob), 'image/png');
  });
}

export function signatureUploadFileName(email: string): string {
  const safe = email.trim().replace('@', '_at_').replace(/\./g, '_');
  return `signature_${safe}.png`;
}
